import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { POSTHOG_KEY, POSTHOG_HOST } from '../constants';

const options = {
  api_host: POSTHOG_HOST,
  defaults: '2025-05-24',
  person_profiles: 'identified_only'
};

posthog.init(POSTHOG_KEY, options);

export const PHProvider = ({ children }) => {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
